import { c as _c } from "react/compiler-runtime";
import { useSessionStore } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { AI_ASSISTANT_API_BASE_URL, chatKitSessionBody } from '../constants';
import { ChatKitSessionResponse } from '../types';
const CHAT_KIT_STORAGE_NAMESPACE = 'ai-chatkit';
export const useChatKitActions = () => {
  const $ = _c(20);
  const {
    userContextKey
  } = useUser();
  let t0;
  if ($[0] !== userContextKey) {
    t0 = {
      namespace: CHAT_KIT_STORAGE_NAMESPACE,
      userContextKey,
      useSessionStorage: true
    };
    $[0] = userContextKey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sessionStore = useSessionStore("session", t0);
  let t1;
  if ($[2] !== userContextKey) {
    t1 = {
      namespace: CHAT_KIT_STORAGE_NAMESPACE,
      userContextKey,
      useSessionStorage: true
    };
    $[2] = userContextKey;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const threadIdStore = useSessionStore("thread-id", t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.post
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    fetcher: clientSecretFetcher
  } = useFetch(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      method: RequestMethodsEnum.post
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    fetcher: escalateFetcher
  } = useFetch(t3);
  let t4;
  if ($[6] !== clientSecretFetcher || $[7] !== sessionStore) {
    t4 = async () => {
      const data = sessionStore.getItem();
      const fetchAndStore = async () => {
        const {
          clientSecret,
          expiresAt
        } = await clientSecretFetcher(`${AI_ASSISTANT_API_BASE_URL}/chatkit/session`, chatKitSessionBody);
        sessionStore.setItem({
          clientSecret,
          expiresAt
        });
        return clientSecret;
      };
      if (data) {
        const currentTime = Math.floor(Date.now() / 1000);
        if (data.expiresAt <= currentTime) {
          return fetchAndStore();
        } else {
          return data.clientSecret;
        }
      } else {
        return fetchAndStore();
      }
    };
    $[6] = clientSecretFetcher;
    $[7] = sessionStore;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const getClientSecret = t4;
  let t5;
  if ($[9] !== escalateFetcher) {
    t5 = async params => escalateFetcher(`${AI_ASSISTANT_API_BASE_URL}/support/escalate`, params);
    $[9] = escalateFetcher;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const escalateSupportRequest = t5;
  let t6;
  if ($[11] !== threadIdStore) {
    t6 = threadId => {
      if (threadId) {
        threadIdStore.setItem(threadId);
      } else {
        threadIdStore.removeItem();
      }
    };
    $[11] = threadIdStore;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const setThreadId = t6;
  let t7;
  if ($[13] !== threadIdStore) {
    t7 = () => threadIdStore.getItem() ?? null;
    $[13] = threadIdStore;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const getThreadId = t7;
  let t8;
  if ($[15] !== escalateSupportRequest || $[16] !== getClientSecret || $[17] !== getThreadId || $[18] !== setThreadId) {
    t8 = {
      getClientSecret,
      escalateSupportRequest,
      setThreadId,
      getThreadId
    };
    $[15] = escalateSupportRequest;
    $[16] = getClientSecret;
    $[17] = getThreadId;
    $[18] = setThreadId;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};